export default {
  hasPassedRfQuiz: false,
  hasPassedMmQuiz: false,
  hasPassedLmQuiz: false,
  badges: []
};
